import { Area } from 'react-easy-crop'

export const MAX_LOGO_SIZE = 5 * 1024 * 1024 // 5MB

export const ACCEPTED_LOGO_TYPES = {
  'image/jpeg': ['.jpg', '.jpeg'],
  'image/png': ['.png'],
  'image/svg+xml': ['.svg'],
  'image/webp': ['.webp'],
}

export function getCroppedImage(
  imageSrc: string,
  cropArea: Area,
): Promise<File> {
  return new Promise((resolve, reject) => {
    const image = new Image()
    image.onload = () => {
      const canvas = document.createElement('canvas')
      canvas.width = cropArea.width
      canvas.height = cropArea.height
      const ctx = canvas.getContext('2d')
      if (!ctx) {
        reject(new Error('Failed to get canvas context'))
        return
      }
      ctx.drawImage(
        image,
        cropArea.x,
        cropArea.y,
        cropArea.width,
        cropArea.height,
        0,
        0,
        cropArea.width,
        cropArea.height,
      )
      canvas.toBlob((blob) => {
        if (!blob) {
          reject(new Error('Failed to create blob'))
          return
        }
        resolve(new File([blob], 'logo.png', { type: 'image/png' }))
      }, 'image/png')
    }
    image.onerror = reject
    image.src = imageSrc
  })
}

export function isSquareImage(file: File): Promise<boolean> {
  return new Promise((resolve) => {
    const img = new Image()
    img.onload = () => {
      URL.revokeObjectURL(img.src)
      resolve(img.width === img.height)
    }
    img.onerror = () => resolve(false)
    img.src = URL.createObjectURL(file)
  })
}
